import { Button, styled } from '@mui/material';
import React from 'react';

export interface IRoundButtonProps {
    icon?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    dense?: boolean;
    onClick?(): void;
}

const StyledButton = styled(Button)({
    borderRadius: 100,
    padding: 12,
    width: 44,
    height: 44,
    minWidth: 'auto',

    '&.MuiButton-contained': {
        width: 36,
        height: 36,
        padding: 8,
    },
    '& .MuiButton-label': {
        width: 20,
    },
});

export const RoundButton = (props: IRoundButtonProps) => {
    const { icon, onClick, className, style, dense, children } = props;

    return (
        <Button
            variant="contained"
            color="primary"
            classes={StyledButton}
            onClick={onClick}
            className={className}
            style={style}
            size={dense ? 'small' : undefined}
        >
            {icon || children}
        </Button>
    );
};

export default RoundButton;
